var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-img-wrap"},[_c('div',{staticClass:"header-img",style:(_vm.headerImg)})])
}
var staticRenderFns = []

export { render, staticRenderFns }